/* eslint-disable */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getApiUrl } from "../auth/apiClient";

const STORAGE_KEY = "vs_visitor_token";

function uuidv4() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  // RFC4122-ish fallback for old browsers.
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (c ^ ((window.crypto?.getRandomValues(new Uint8Array(1))[0] ?? 0) & (15 >> (c / 4)))).toString(16)
  );
}

export function getVisitorToken() {
  try {
    let t = localStorage.getItem(STORAGE_KEY);
    if (!t) {
      t = uuidv4();
      localStorage.setItem(STORAGE_KEY, t);
    }
    return t;
  } catch (_) {
    return "";
  }
}

/**
 * Mount once at the top of the app. Fires a single ``view.page``
 * event on every route change with the current pathname. Silent
 * failures — never breaks the page if the tracker is unreachable.
 */
export default function PageViewTracker() {
  const location = useLocation();
  const lastPathRef = useRef("");

  useEffect(() => {
    const path = location.pathname || "/";
    if (path === lastPathRef.current) return;
    lastPathRef.current = path;

    const token = getVisitorToken();
    const body = {
      event_type: deriveEventType(path),
      path,
      referrer: document.referrer || null,
    };

    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (token) headers["X-Visitor-Token"] = token;
      const access = localStorage.getItem("access_token");
      if (access) headers["Authorization"] = `Bearer ${access}`;
      // navigator.sendBeacon would be nicest but doesn't support
      // custom headers. fetch keepalive is the next-best thing.
      fetch(`${getApiUrl()}/api/track`, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
        keepalive: true,
      }).catch(() => {});
    } catch (_) {
      // Tracker must never throw to the app.
    }
  }, [location.pathname]);

  return null;
}

function deriveEventType(path) {
  if (path === "/" || path === "") return "view.home";
  if (path.startsWith("/properties")) return "view.property";
  if (path.startsWith("/directory")) return "view.directory";
  if (path.startsWith("/board")) return "view.board";
  return "view.page";
}
